
import React from "react";
import { useNavigate } from "react-router-dom";
import Placeholder from "./placeholder";

export default function AuditLog() {
  return <Placeholder title="Audit Log" description="Complete audit trail of all project activities and changes" />;
}
